// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2RduV","subheader":"ReorderModal_subheader__3c2Os","listWrap":"ReorderModal_listWrap__12yDf"};